import {createRoot} from 'react-dom/client';
import {ConfigProvider} from '@vector';
import 'vector/src/styles/base.css';
import './styles/homeUpdatedTokens.css';
import Home from './HomeUpdated';
import {Route, Switch} from 'wouter';
import QuotePage from './QuotePage';
import LegalPage from './LegalPage';
import EdjinHome from './EdjinHome';
import {setRecaptchaSiteKey} from '../portal/recaptcha';
import {HOME_ANTD_THEME} from './homeTheme';
import {contentForBrand} from './content';

/**
 * Public HOTmaths homepage.
 *
 * Built on `vector`, the design system that until now was scoped to Checkpoints. It is the right
 * foundation for this page because accessibility is designed into it rather than retrofitted: every step
 * of its colour ramp documents its contrast, its semantic colours hold 4.5:1 with no size-based
 * exceptions, and interactive elements get a 48px minimum touch target. The page it replaces paints its
 * primary buttons at 2.70:1.
 *
 * Stylesheet order matters. `base.css` brings vector's reset, tokens and fonts; `hotmathsBrand.css` then
 * re-points the primary ramp from vector's Edjin teal to HOTmaths orange. Vector's semantic tokens are
 * `var()` references to that ramp, so every component follows without vector itself being touched.
 */
const rootElement = document.getElementById('home-root');

if (rootElement) {
    setRecaptchaSiteKey(rootElement.dataset.recaptchaSiteKey);

    // One bundle for the brand's public pages. Each brand lists its pages in its content's `routes`; wouter
    // matches the path, and anything else - "/", /home/homeReact - is the homepage.
    const content = contentForBrand(rootElement.dataset.brandCode);

    createRoot(rootElement).render(
        <ConfigProvider theme={HOME_ANTD_THEME}>
            <Switch>
                {(content.routes || []).map((route) => (
                    <Route key={route.path} path={route.path}>
                        {route.page === 'quote'
                            ? <QuotePage content={content}/>
                            : <LegalPage content={content} page={route}/>}
                    </Route>
                ))}
                <Route>
                    {/* Edjin's is a marketing page, not a product homepage. */}
                    {content.homepage === 'edjin' ? <EdjinHome content={content}/> : <Home content={content}/>}
                </Route>
            </Switch>
        </ConfigProvider>
    );
}
